import { render, staticRenderFns } from "./Coock.vue?vue&type=template&id=578fdc84&scoped=true&"
import script from "./Coock.vue?vue&type=script&lang=js&"
export * from "./Coock.vue?vue&type=script&lang=js&"
import style0 from "./Coock.vue?vue&type=style&index=0&id=578fdc84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fdc84",
  null
  
)

export default component.exports